import { useEffect } from "react";

const SITE = "https://www.360immoinvest.com";

function setMeta(selectorAttr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${selectorAttr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(selectorAttr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, path = "/", jsonLd }) {
  useEffect(() => {
    const url = SITE + path;
    if (title) document.title = title;
    setMeta("name", "description", description);
    setCanonical(url);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    let scripts = [];
    if (jsonLd) {
      scripts = (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((obj) => {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.setAttribute("data-seo-page", "");
        s.textContent = JSON.stringify(obj);
        document.head.appendChild(s);
        return s;
      });
    }
    return () => scripts.forEach((s) => s.remove());
  }, [title, description, path, jsonLd]);

  return null;
}
